import React from "react";
import ObjectiveCard from "../components/ObjectiveCard";
import { FaHeartbeat, FaBookOpen, FaLeaf, FaLightbulb, FaFutbol } from "react-icons/fa";

import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";

export default function OurObjectives() {
 const objectives = [
  {
    title: "Holistic Health & Well-being",
    description:
      "Enhancing access to preventive healthcare, rehabilitation, mental health, sexual and reproductive health, and healthy aging.",
    icon: <FaHeartbeat />,
  },
  {
    title: "Inclusive Education & Youth Empowerment",
    description:
      "Expanding access to quality education, digital & health literacy, entrepreneurship, mentorship, and leadership training for vulnerable youth.",
    icon: <FaBookOpen />,
  },
  {
    title: "Environmental Stewardship",
    description:
      "Fostering eco- and One Health initiatives through climate clubs, tree planting, waste management, and climate adaptation programs.",
    icon: <FaLeaf />,
  },
  {
    title: "Research & Innovation",
    description:
      "Conducting participatory research on health, environment, and community development while sharing findings through publications and innovation hubs.",
    icon: <FaLightbulb />,
  },
  {
    title: "Sports for Social Transformation",
    description:
      "Using sports to promote rehabilitation, physical & mental resilience, environmental advocacy, youth empowerment, and social cohesion.",
    icon: <FaFutbol />,
  },
];

useEffect(() => {
  AOS.init({ duration: 800, once: true });
}, []);
  

  return (
    <div className="mx-auto px-10 md:px-20 mt-20">
      <div className="text-center mb-12">
        <h2 className="text-3xl font-bold text-secondary">What We Do</h2>
        <p className="text-gray-500 mt-3 max-w-xl mx-auto">
          Our objectives guide everything we do. From innovation to sustainability,
          we create solutions and experiences that make a difference.
        </p>
      </div>

      <div className="flex flex-wrap -m-4">
        {objectives.map((item, idx) => (
          <ObjectiveCard 
          key={idx} 
          {...item} 
          data-aos="fade-up"
          data-aos-delay={idx * 100} />
        ))}
      </div>
    </div>
  );
}
